import { render, staticRenderFns } from "./SystemParams.vue?vue&type=template&id=22ac45b9&scoped=true"
import script from "./SystemParams.vue?vue&type=script&lang=js"
export * from "./SystemParams.vue?vue&type=script&lang=js"
import style0 from "./SystemParams.vue?vue&type=style&index=0&id=22ac45b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac45b9",
  null
  
)

export default component.exports